"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _MessageDisplayBanner = _interopRequireDefault(require("./components/MessageDisplayBanner"));

var _MessageDisplayModal = _interopRequireDefault(require("./components/MessageDisplayModal"));

require("./MessageDisplay.css");

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var MODAL_SHOWN = 'showFishermanBannerMessage';

var MessageDisplay = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MessageDisplay, _React$Component);

  var _super = _createSuper(MessageDisplay);

  function MessageDisplay(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, MessageDisplay);
    _this = _super.call(this, props);
    _this.state = {
      showModal: false,
      showBanner: true
    };
    _this.withinTimeFrame = _this.withinTimeFrame.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleModal = _this.toggleModal.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleBanner = _this.toggleBanner.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MessageDisplay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var modalDelay = this.props.modalDelay;

      if (modalDelay !== false && !this.getModalShownInSession()) {
        setTimeout(this.toggleModal, modalDelay);
      }
    }
  }, {
    key: "withinTimeFrame",
    value: function withinTimeFrame() {
      var _this$props = this.props,
          startTime = _this$props.startTime,
          endTime = _this$props.endTime; // If not end time set, always show

      if (!endTime) return true; // If not start time but end time, just check if now is before end time
      else if (!startTime && endTime) {
          return (0, _moment["default"])().isBefore(endTime);
        } else {
          return (0, _moment["default"])().isAfter(startTime) && (0, _moment["default"])().isBefore(endTime);
        }
    }
  }, {
    key: "setModalShownInSession",
    value: function setModalShownInSession(isShown) {
      var disableCache = this.props.disableCache;
      var hasWindowObj = typeof window !== "undefined";

      if (hasWindowObj && !disableCache) {
        window.sessionStorage.setItem(MODAL_SHOWN, isShown);
      }
    }
  }, {
    key: "getModalShownInSession",
    value: function getModalShownInSession() {
      var disableCache = this.props.disableCache; // If session cache is disabled, always return false so modal is shown

      if (disableCache) {
        return false;
      }

      var hasWindowObj = typeof window !== "undefined";

      if (hasWindowObj) {
        return window.sessionStorage.getItem(MODAL_SHOWN);
      }

      return null;
    }
  }, {
    key: "toggleModal",
    value: function toggleModal() {
      var _this2 = this;

      this.setState(function (_ref) {
        var showModal = _ref.showModal; // If we are showing the modal, make sure
        // we don't show it again in the same session

        if (showModal) {
          _this2.setModalShownInSession(true);
        }

        return {
          showModal: !showModal
        };
      });
    }
  }, {
    key: "toggleBanner",
    value: function toggleBanner() {
      this.setState(function (_ref2) {
        var showBanner = _ref2.showBanner;
        return {
          showBanner: !showBanner
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          businessName = _this$props2.businessName,
          subject = _this$props2.subject,
          content = _this$props2.content,
          bannerBackgroundColor = _this$props2.bannerBackgroundColor,
          modalExtra = _this$props2.modalExtra,
          modalButtonText = _this$props2.modalButtonText,
          disableModalButton = _this$props2.disableModalButton;
      var _this$state = this.state,
          showModal = _this$state.showModal,
          showBanner = _this$state.showBanner;
      return this.withinTimeFrame() && /*#__PURE__*/_react["default"].createElement("div", {
        className: "fm-message-display-container"
      }, showBanner && /*#__PURE__*/_react["default"].createElement(_MessageDisplayBanner["default"], {
        subject: subject,
        onClick: this.toggleModal,
        onClose: this.toggleBanner,
        backgroundColor: bannerBackgroundColor,
        buttonText: modalButtonText,
        disableButton: disableModalButton
      }), /*#__PURE__*/_react["default"].createElement(_MessageDisplayModal["default"], {
        businessName: businessName,
        open: showModal,
        subject: subject,
        content: content,
        onClose: this.toggleModal,
        extra: modalExtra
      }));
    }
  }]);
  return MessageDisplay;
}(_react["default"].Component);

exports["default"] = MessageDisplay;
MessageDisplay.propTypes = {
  businessName: _propTypes["default"].string.isRequired,
  subject: _propTypes["default"].string.isRequired,
  content: _propTypes["default"].string.isRequired,
  modalDelay: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),
  bannerBackgroundColor: _propTypes["default"].string,
  modalButtonText: _propTypes["default"].string,
  modalExtra: _propTypes["default"].element,
  disableCache: _propTypes["default"].bool,
  disableModalButton: _propTypes["default"].bool,
  startTime: _propTypes["default"].string,
  endTime: _propTypes["default"].string
};
MessageDisplay.defaultProps = {
  modalDelay: false,
  bannerBackgroundColor: '',
  modalButtonText: 'See More',
  modalExtra: /*#__PURE__*/_react["default"].createElement("div", null),
  disableCache: false,
  disableModalButton: false,
  startTime: '',
  endTime: ''
};